import React from 'react';
import classNames from 'classnames';
import {TextFieldProps} from '@material-ui/core';
import AppInput from '../AppInput/AppInput';

export type AppTextFieldProps = TextFieldProps;

export default function AppTextField({
    className, inputRef, InputProps, ...rest
}: AppTextFieldProps) {
    const containerClassName = classNames('app-text-field', className);
    const {ref: inputPropsRef, ...inputPropsRest} = InputProps || {};

    return (
        <AppInput
            {...rest as any}
            {...inputPropsRest}
            className={containerClassName}
            inputRef={inputRef || inputPropsRef}
        />
    );
}
